import React from "react";
import DetailCard from "./DetailCard";
import Page from "components/Page";
import { withTranslation } from "react-i18next";
import Offices from "./Offices";
import { Link } from "react-router-dom";
import { decodeId, encodeId } from "utils";
import { useUser } from "repositories/user-repository";

function AccountOwnerDetail({ history, match, t }) {
  const accountOwnerId = decodeId(match.params.accountOwnerId);
  const { isLoading, data: apiRes, error, refetch } = useUser(accountOwnerId);
  const onBack = () => history.push({ pathname: "/manage-owner" });

  const handleAISettingsRedirection = () => {
    history.push({
      pathname: `/account-owner/${encodeId(accountOwnerId)}/manage-ai-settings`,
    });
  };

  const handledRedirectionForPersonalOfficeList = () => {
    history.push({
      pathname: `/personnel/${encodeId(accountOwnerId)}`,
    });
  };

  if (history.location.state !== undefined) {
    const { personnelName } = history.location.state;

    return (
      <Page
        titleKey="superAdmin.accountOwnerDetail"
        onBack={handledRedirectionForPersonalOfficeList}
      >
        <DetailCard
          accountOwnerId={accountOwnerId}
          fromPersonnel={true}
          personnelName={personnelName}
          isLoading={isLoading}
          apiRes={apiRes}
          error={error}
          refetch={refetch}
          action={
            <button
              onClick={handledRedirectionForPersonalOfficeList}
              className="button button-round button-shadow button-width-large"
            >
              {t("superAdmin.viewPersonnelOfficeListOf")} {personnelName}
            </button>
          }
        />
      </Page>
    );
  } else {
    return (
      <Page titleKey="superAdmin.accountOwnerDetail" onBack={onBack}>
        <DetailCard
          accountOwnerId={accountOwnerId}
          isLoading={isLoading}
          apiRes={apiRes}
          error={error}
          refetch={refetch}
          action={
            <div className="d-flex flex-row">
              <Link
                to={`/account-owner/${encodeId(
                  accountOwnerId
                )}/subscription-and-invoices`}
              >
                <button className="button button-round button-shadow button-width-large mr-4">
                  {t("superAdmin.viewSubscriptionDetails")}
                </button>
              </Link>
              <Link
                to={`/account-owner/${encodeId(
                  accountOwnerId
                )}/transaction-history`}
              >
                <button className="button button-round button-border button-dark">
                  {t("superAdmin.viewTransactionHistory")}
                </button>
              </Link>
              <button
                className="button button-round button-border button-dark ml-4"
                onClick={() => handleAISettingsRedirection()}
              >
                {t("aiAssistant.manageAISettings.manageAISettings")}
              </button>
            </div>
          }
        />

        <div className="margin30">
          <Offices accountOwnerId={accountOwnerId} />
        </div>
      </Page>
    );
  }
}

export default withTranslation()(AccountOwnerDetail);
